module.exports = __webpack_public_path__ + "static/tiesto_2-8a631d559c5b726eed57af5539174f2e.jpg";